import * as React from 'react';
import styled from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import displayDuration from '@sdk/utils/displayDuration';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import type { FormattedDateString } from '../types/FormattedDateString';
import type { RowDataType } from '../types/RowType';
import Flex1 from '../ui/Flex1';

import UnassignedRow from './UnassignedRow';

const BORDER_COLOR = 'rgba(0, 0, 0, 0.08)';

const Cell = styled(Flex1)<{ leftBorder?: boolean }>`
  border-left: ${({ leftBorder }): number => (leftBorder ? 1 : 0)}px solid ${BORDER_COLOR};
  border-top: 1px solid ${BORDER_COLOR};
  padding-top: 10px;
  padding-left: 2px;
  padding-right: 2px;
  height: 30px;
`;
Cell.displayName = 'Cell';

type Props = {
  columns: Array<FormattedDateString>;
  rowData: RowDataType;
};
const UnassignedSummaryRow: React.FC<React.PropsWithChildren<Props>> = ({ columns, rowData }) => {
  const { hasNameColumn = true, summary } = rowData;
  return (
    <UnassignedRow>
      {hasNameColumn && <Cell leftBorder={false} />}
      {columns.map((day) => (
        <Cell key={day} leftBorder>
          <Text12 themeColor={ThemeColorType.iconGray}>{displayDuration(summary[day])}</Text12>
        </Cell>
      ))}
    </UnassignedRow>
  );
};

export default UnassignedSummaryRow;
